// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stone-rebrand-icon__svg[data-v-67359d96]{display:block}", ""]);
// Exports
module.exports = exports;
